<template>
  <div class="page-calendar">
    <div class="columns is-multiline">
      <div class="column is-12-mobile is-3-tablet">
        <InputSelect
          name="Collaboratore"
          v-model="filters.operator"
          :options="$store.getters.operators"
          id="_id"
          track-by="_id"
          :custom-label="$fullname"
        />
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <router-link v-if="$store.getters.amAdmin" to="/appuntamenti/new" class="button is-primary">
            <font-awesome-icon icon="plus" /> Nuovo
          </router-link>
        </div>
      </div>
    </div>

    <WeekCalendar v-if="loadCalendar" :operator="filters.operator" :canEdit="$store.getters.amAdmin ? true : false" :activeView="activeView" @viewChange="updateLastView" :activeDate="activeDate" @ready="scrollToToday()" hideCancelled />

  </div>
</template>

<script>
import utils from '../utils'

export default {
  data() {
    return {
      filters: this.$store.state.filters.operationCalendar,

      activeView: 'week',
      activeDate: undefined,

      loadCalendar: false
    }
  },

  methods: {
    resetFilters() {
      this.filters = {
        operator: null
      }
    },

    updateLastView(e) {
      this.$store.state.pages.calendar.lastView = e
    },

    scrollToToday() {
      if (this.activeView === 'week' && (!this.activeDate || this.activeDate.setHours(0,0,0,0) === utils.getFirstDayOfWeek().setHours(0,0,0,0))) {
        const cellWidth = document.querySelector('.vuecal__flex .week-day-cell').offsetWidth
        const calendar = document.querySelector('.vuecal__flex.vuecal__cells.week-view')

        const diffTime = Math.abs(new Date() - utils.getFirstDayOfWeek())
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        calendar.scrollTo({ left: cellWidth * diffDays, behavior: 'smooth' })
    }
    }
  },

  mounted() {
    if (this.$store.state.filters.operationCalendar.operator === undefined && this.$store.getters.amOperator) {
      this.filters.operator = this.$store.state.user
      this.$store.commit('setFilter', {name: 'operationCalendar', value: this.filters})
      this.activeView = 'day'
    }

    const lastView = this.$store.state.pages.calendar.lastView
    if (lastView) {
      this.activeView = lastView.view
      this.activeDate = lastView.startDate
    }

    this.loadCalendar = true
  }
}
</script>

<style lang="scss">
@import "../variables.scss";

.custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;
  border-radius: 0;
  width: 100%;

  & .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }
  & .vc-weeks {
    padding: 0;
  }
  & .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
  & .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;
    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }
    &:not(.on-bottom) {
      border-bottom: var(--day-border);
      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    &:not(.on-right) {
      border-right: var(--day-border);
    }
  }
  & .vc-day-dots {
    margin-bottom: 5px;
  }
}

.appointment-card {
background: #0087d944;
border-left: 5px solid $primary;
//color: #ffffff;
font-weight: 700;
font-size: .75rem;
}
</style>